import { useEffect } from "react";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";

const RELEASES: { version: string; date: string; items: string[] }[] = [
  {
    version: "1.0.0",
    date: "2025-02-09",
    items: [
      "Compliance pack: Privacy, Terms, Cookies, DPA, Support, FAQ, Changelog, Status pages",
      "Cookie consent banner and preferences (EU/IT compliant)",
      "Global footer and public layout",
      "Support ticket form and status page",
    ],
  },
  {
    version: "0.9.0",
    date: "2025-01-20",
    items: [
      "Premium UI upgrade: iconography and motion tokens",
      "Interactive feature cards and marketing layout",
      "Trial and Pro workspace flows",
    ],
  },
  {
    version: "0.8.0",
    date: "2024-12-15",
    items: [
      "Multi-tenant workspace structure",
      "Revenue Flow and pipeline improvements",
      "Analytics events and referrals",
    ],
  },
];

export default function ChangelogPage() {
  useEffect(() => {
    document.title = "Changelog | Decision Sales OS";
  }, []);

  return (
    <PublicLayout showCookieBanner={false}>
      <h1 className="text-3xl font-semibold tracking-tight mb-4">Changelog</h1>
      <p className="text-muted-foreground mb-8">
        Release history and product updates.
      </p>

      <div className="space-y-8">
        {RELEASES.map((release, i) => (
          <Card key={release.version}>
            <CardHeader className="pb-2">
              <div className="flex items-center gap-2 flex-wrap">
                <CardTitle className="text-lg">{release.version}</CardTitle>
                <Badge variant="secondary">{release.date}</Badge>
              </div>
            </CardHeader>
            <CardContent>
              <ul className="list-disc list-inside space-y-1 text-muted-foreground text-sm">
                {release.items.map((item, j) => (
                  <li key={j}>{item}</li>
                ))}
              </ul>
            </CardContent>
            {i < RELEASES.length - 1 && <Separator className="mx-6 mb-0" />}
          </Card>
        ))}
      </div>
    </PublicLayout>
  );
}
